var map = {
	"./axe.salvaged.png": "6482",
	"./bone.club.png": "93a6",
	"./bow.compound.png": "4435",
	"./bow.hunting.png": "afa0",
	"./cakefiveyear.png": "a2f4",
	"./chainsaw.png": "6993",
	"./cloth.png": "8546",
	"./concretehatchet.png": "9975",
	"./concretepickaxe.png": "6480",
	"./crossbow.png": "963a",
	"./explosive.satchel.png": "7bdf",
	"./explosive.timed.png": "9d17",
	"./flare.png": "f4c3",
	"./grenade.beancan.png": "1322",
	"./grenade.f1.png": "ffe8",
	"./gun.water.png": "6442",
	"./hammer.salvaged.png": "f5a0",
	"./hat.wolf.png": "b3c1",
	"./hatchet.png": "15ec",
	"./hazmatsuit.png": "b9f2",
	"./hmlmg.png": "c9ed",
	"./jackhammer.png": "1222",
	"./keycard_blue.png": "4b14",
	"./keycard_green.png": "779b",
	"./keycard_red.png": "7065",
	"./knife.bone.png": "54d0",
	"./knife.butcher.png": "c0fe",
	"./knife.combat.png": "5015",
	"./lmg.m249.png": "f004",
	"./locked_crate.png": "2d0f",
	"./logo.png": "cf05",
	"./longsword.png": "c32e",
	"./lumberjack.hatchet.png": "f17a",
	"./lumberjack.pickaxe.png": "51201",
	"./mace.png": "f45e",
	"./machete.png": "7dc0",
	"./metal.ore.png": "f153",
	"./paintballgun.png": "8d58",
	"./pickaxe.png": "5f20",
	"./pistol.eoka.png": "1fd7",
	"./pistol.m92.png": "4051",
	"./pistol.nailgun.png": "600e",
	"./pistol.prototype17.png": "cf56",
	"./pistol.python.png": "f2f5",
	"./pistol.revolver.png": "f420",
	"./pistol.semiauto.png": "3892",
	"./pistol.water.png": "9d19",
	"./rifle.ak.ice.png": "7a34",
	"./rifle.ak.png": "7ba4",
	"./rifle.bolt.png": "cade",
	"./rifle.l96.png": "cc88",
	"./rifle.lr300.png": "3aa4",
	"./rifle.lr300.space.png": "99b9",
	"./rifle.m39.png": "422a",
	"./rifle.semiauto.png": "4bf4",
	"./rock.png": "8e41",
	"./rocket.launcher.png": "ea53",
	"./salvaged.cleaver.png": "bfc2",
	"./salvaged.sword.png": "d3cb",
	"./shotgun.double.png": "1106",
	"./shotgun.pump.png": "deae",
	"./shotgun.spas12.png": "e367",
	"./skull.png": "d17a",
	"./smg.2.png": "e669",
	"./smg.mp5.png": "fb46",
	"./smg.thompson.png": "23fb",
	"./spear.stone.png": "14d4",
	"./spear.wooden.png": "8bf5",
	"./speargun.png": "a1a0",
	"./stone.pickaxe.png": "cdf3",
	"./stonehatchet.png": "ef7e",
	"./stones.png": "8739",
	"./sulfur.ore.png": "00ff",
	"./torch.png": "84e0",
	"./vending.machine.png": "fa84",
	"./wood.png": "b196"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";